import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class PECCardsAvailability extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'Do You Have a Valid PEC Safety Training Card(s)\n',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: true,
    modalTitle: 'Add Information About Your Valid PEC Safety Training Card(s)',
    additionalFormComponent: 'SafetyCardsForm',
  };
  jumpedFrom = 8;
}
